var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"me-2 fw-bold"},[_vm._v(_vm._s(_vm.rating)+".0")]),_vm._l((Array(_vm.maxRating).fill('')),function(_,index){return _c('span',{key:'rating-' + index},[(index + 1 <= _vm.rating)?_c('span',{staticClass:"fas fa-xl fa-star text-warning"}):_c('span',{staticClass:"fas fa-xl fa-star text-light"})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }